<template>
  <!-- <h3 class="font-semibold text-gray-700 text-xl">Cajas por calibre</h3> -->
  <div id="chart5">
    <apexchart height="350" width="100%" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "AEProductionQueryByProvidersGraphicsCropSizePackagesByMonths",
  components: {
    apexchart: VueApexCharts
  },
  props: { data: { required: true } },
  data() {
    return {
      options: {
        chart: {
          height: 350,
          type: 'bar',
          toolbar: { show: true },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 2,
            dataLabels: {
            }
          }
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.data.months,
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: val => this.numberWithPrecision(val)
          }
        },
        title: {
          text: "Calibres (cajas)",
          offsetX: 15,
          style: { fontSize: "20px" }
        },
        legend: {
          position: "bottom",
        },
        yaxis: {
          labels: {
            show: true,
            formatter: val => this.numberWithPrecision(val)
          }
        },
        fill: {
          opacity: 1
        },
        colors: [
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#3b82f6",
          "#a855f7",
          "#f43f5e",
          "#eab308"
        ]
      }
    };
  },
  computed: {
    series() {
      let series = [];
      if (this.data.crop_sizes)
        this.data.crop_sizes?.forEach(crop_size => {
          series.push({
            name: crop_size.name,
            data: this.cropSizeData(crop_size),
            type: 'column'
          });
        })
      return series;
    },
  },
  methods: {
    barWidth() {
      if (this.data.months?.length < 3) return "20%";
      if (this.data.months?.length < 6) return "50%";
      return "70%";
    },
    cropSizeData: function (crop_size) {
      let data = [];
      if (this.data.months)
        this.data?.months?.forEach(month => {
          let pk = this.data?.packages?.find(pkg => pkg.month == month && pkg.exporter_process_crop_size_id == crop_size.id);
          let quantity = pk?.quantity || 0;
          data.push(quantity);
        })
      return data;
    }
  }
};
</script>
